import React, { ChangeEvent, MouseEvent } from 'react';
import { useEffect, useState } from 'react';
import MUITablePagination from '@mui/material/TablePagination';

import { TablePaginationProps } from './props';

export const TablePagination = <T,>(props: TablePaginationProps<T>) => {
  const {
    data = [],
    page = 0,
    rowsPerPage = 10,
    rowsPerPageOptions = [15, 45, 75, 100],
    onPageChange,
    onRowsPerPageChange,
    ...restProps
  } = props;

  // ================== STATE
  const [pageState, setPageState] = useState(page);
  const [rowsPerPageState, setRowsPerPageState] = useState(rowsPerPage);

  // ================== EFFECTS
  useEffect(() => setPageState(page), [page]);
  useEffect(() => setRowsPerPageState(rowsPerPage), [rowsPerPage]);

  // ================== EVENTS
  const handleChangePage = (
    event: MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageState(newPage);
    onPageChange?.(newPage);
  };

  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const perPage = parseInt(event.target.value, 10);
    setPageState(0);
    setRowsPerPageState(perPage);
    onRowsPerPageChange?.(perPage);
  };

  // ================== VIEWS
  return (
    <MUITablePagination
      component="div"
      sx={{
        position: 'sticky',
        left: 0,
      }}
      {...restProps}
      count={restProps?.count ?? data.length}
      page={pageState}
      rowsPerPage={rowsPerPageState}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};

// ======================= EXPORT
export default TablePagination;
